import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormGroup, Input } from "reactstrap";
import _ from "lodash/fp";
import UpdateShoppingCart from "../containers/UpdateShoppingCart";

const ChangeQuantity = ({
  quantity,
  shoppingCart,
  itemId,
  customerId,
  dealerId,
  updateShoppingCart
}) => {
  const onChangeQuantity = useCallback(
    ev => {
      const qty = _.toNumber(ev.target.value);
      if (qty > 0) {
        const item = _.pipe(
          _.getOr([], "purchased_products"),
          _.find(pp => pp.id === itemId),
          x => Object.assign({}, x, { quantity: qty })
        )(shoppingCart);
        const data = {
          shopping_cart: {
            purchased_products_attributes: [
              ..._.reject(
                pp => pp.id === itemId,
                shoppingCart.purchased_products_attributes
              ),
              item
            ]
          }
        };
        updateShoppingCart({ dealerId, customerId, data });
      }
    },
    [customerId, dealerId, itemId, shoppingCart, updateShoppingCart]
  );
  return (
    <FormGroup inline>
      <Input
        min={1}
        type="number"
        value={quantity}
        onChange={onChangeQuantity}
      />
    </FormGroup>
  );
};

ChangeQuantity.propTypes = {
  quantity: PropTypes.number.isRequired,
  itemId: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  dealerId: PropTypes.number.isRequired,
  updateShoppingCart: PropTypes.func.isRequired
};

export default UpdateShoppingCart(ChangeQuantity);
